import { render, staticRenderFns } from "./HealthReportCreate.vue?vue&type=template&id=7973bb50&"
import script from "./HealthReportCreate.vue?vue&type=script&lang=js&"
export * from "./HealthReportCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports